var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#409BD2",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D1EA",
    mask: "url(#b)",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4E8B1",
    mask: "url(#b)",
    d: "M-5 8h34v8H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409BD2",
    mask: "url(#b)",
    d: "M8 8h21v8H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4E8B1",
    mask: "url(#b)",
    d: "M8-5h8v34H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409BD2",
    mask: "url(#b)",
    d: "M8 8h8v21H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4CD58",
    mask: "url(#b)",
    d: "M8 8h16v16H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5202E",
    mask: "url(#b)",
    d: "M8 8h8v8H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AC3",
    mask: "url(#b)",
    d: "M16 16h8v8h-8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelSmall);
export default __webpack_public_path__ + "static/media/wheel-small.e75521509d06c38e630590822ee34f15.svg";
export { ForwardRef as ReactComponent };